import { Injectable } from "@angular/core";


@Injectable()
export class CookieService {

    public getAll(): {} {
        let pairs = document.cookie.split(";").filter(x => x);
        let cookies = {};
        for (let i = 0; i < pairs.length; i++) {
            let pair = pairs[i].split("=");
            cookies[(pair[0] + '').trim()] = unescape(pair[1]);
        }
        return Object.keys(cookies).length == 0 ? null : cookies;
    }
    public get(...keys): any {
        let cookies = this.getAll();

        if (cookies != null && keys.length != 0) {
            let filtered = Object.keys(cookies)
                .filter(key => keys.includes(key))
                .reduce((obj, key) => {
                    obj[key] = cookies[key];
                    return obj;
                }, {});

            if (Object.keys(filtered).length == 1)
                return Object.values(filtered)[0];
            else if (Object.keys(filtered).length > 1)
                return filtered;
            else
                return null;
        }
        return null;
    }
    public set(key: string, value: string, domain: string = null, path = "/") {
        let data = `${key}=${value};path=${path};`;

        if (domain != null)
            data += `domain=${domain};`;

        document.cookie = data;
    }
    public delete(...keys) {
        let cookies = this.getAll();
        if (cookies != null && keys.length != 0) {
            let filtered = Object.keys(cookies)
                .filter(key => keys.includes(key))
                .reduce((obj, key) => {
                    obj[key] = cookies[key];
                    return obj;
                }, {});
            Object.keys(filtered).forEach(key => {
                document.cookie = `${key}=;path=/;expires=${new Date(0).toUTCString()};`
            });
        }
    }
    public deleteAll() {
        let cookies = this.getAll();
        if (cookies != null) {
            let keys = Object.keys(cookies);
            keys.forEach(key => {
                document.cookie = `${key}=;path=/;expires=${new Date(0).toUTCString()};`
            });
        }
    }
}